import { Stack } from '@/components/layout/stack';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { useScaling } from '@/hooks';
import React, { memo } from 'react';

export type PlayerListTemplateV2EmptyProps = {
  text?: string;
};

/**
 * Default empty placeholder. Screens can pass a custom `text`, or render
 * `<PlayerListTemplateV2.Empty>` as the `ListEmptyComponent` on `List`.
 */
function EmptyComponent({ text }: PlayerListTemplateV2EmptyProps) {
  const { scale } = useScaling();
  return (
    <Stack align="center" justify="center" flex={1} marginTop={scale(100)}>
      <Text variant="Font Inter/Subtitle/Medium 12px">
        {text ?? STRINGS.player.listPlayers.emptyListMessage}
      </Text>
    </Stack>
  );
}

export const Empty = memo(EmptyComponent);
Empty.displayName = 'PlayerListTemplateV2.Empty';
